import axios from "axios";

const LOG_API_KEY = process.env.REACT_APP_LOG_API_KEY as string;
const LOG_API_URL = `${
  process.env.REACT_APP_LOG_API_ENDPOINT as string
}/v1/log`;

type ActionType =
  | "press_call"
  | "call_ended"
  | "press_callback"
  | "submitted_callback"
  | "call_transferred"
  | "join_call";

export const logLobbyAction = async (
  lobbynumber: string,
  action: ActionType,
  payload: Record<string, any> = {}
) => {
  try {
    const response = await axios.post(
      LOG_API_URL,
      {
        lobbynumber,
        action,
        payload,
      },
      {
        headers: {
          Authorization: `Bearer ${LOG_API_KEY}`,
          "Content-Type": "application/json",
        },
      }
    );
    // ISO27018: do not log response payload (may echo PII from the request)
    // console.log("[LogService] Logged successfully:", response.data);
    return response.data;
  } catch (error) {
    console.error("[LogService] Logging failed", error);
    throw error;
  }
};

export const loggingService = async (
  action: ActionType,
  payload: any,
  errorMessage?: string
) => {
  const transactionCode = sessionStorage.getItem("transactionCode");

  if (transactionCode) {
    try {
      await logLobbyAction(transactionCode, action, payload);
    } catch (error) {
      console.error(
        errorMessage || `[Logging] Logging failed for ${action}:`,
        error
      );
    } finally {
      if (action === "call_ended" || action === "submitted_callback") {
        sessionStorage.removeItem("transactionCode");
      }
    }
  }
};
